<template>
	<page>
		<module v-if="freeEdition" height="auto">
			<div class="bg"></div>
			<div class="main flex-column flex-center">
				<h1><span>12年</span>技术沉淀 工厂数字化立杆见影</h1>
				<h2>产品广泛应用于五金、机加工、注塑、印刷、电子元器件、仪器仪表、家具、玩具、新能源、汽配等30+细分行业</h2>
				<div class="version flex-between">
					<div class="item flex-column flex-center-cross" style="border-top-color: #CCD6E7;">
						<p class="title">免费版</p>
						<p class="explain">适合小微企业，报工人数小于5人</p>
						<p class="sum">￥0<span> / 年</span></p>
						<div class="button flex-center" style="border: 1px solid #ccc;">正在使用</div>
						<dl>
							<dd>
								<ul>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">子账号数</p>
										<p>5个</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">产品物料</p>
										<p>60个</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">手机报工</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">销售管理</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">快速排产</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">采购管理</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">生产管理</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">库存管理</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">车间看板</p>
									</li>
								</ul>
							</dd>
						</dl>
					</div>
					<div class="item flex-column flex-center-cross" style="border-top-color: #4D4F5B;">
						<p class="title" style="color: #9F5A16;">专业版</p>
						<p class="explain">开通所有功能，工厂数字化立竿见影</p>
						<p class="sum">￥6800<span> / 年</span></p>
						<div class="button flex-center" style="color: #EECCAA; background: #2B2B2F;" @click="getSys().$refs.businessService.open();">
							<span>立即升级</span>
							<img src="@/assets/image/upgrade_tips.png" alt="">
						</div>
						<dl>
							<dt>
								<p>较免费版增加：</p>
							</dt>
							<dd>
								<ul>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">子账号数</p>
										<p>60个</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">产品物料</p>
										<p>不限制</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">系统实施</p>
										<p>一对一服务</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">装配工单</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">质量管理</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">委外管理</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">自定义数据大屏</p>
									</li>
								</ul>
							</dd>
						</dl>
					</div>
					<div class="item flex-column flex-center-cross" style="border-top-color: #9797C2;">
						<p class="title" style="color: #2E316B;">私有部署版</p>
						<p class="explain">专享私有部署，满足大企业个性化需求</p>
						<p class="sum">详询报价</p>
						<div class="button flex-center" style="color: #fff; background: #616496;" @click="getSys().$refs.businessService.open();">立即咨询</div>
						<dl>
							<dt>
								<p><b>包含专业版所有权益：</b></p>
								<p>以专业版的功能为基础，根据客户企业实际要求开发个性化功能，快速落地上线。</p>
							</dt>
							<dd>
								<ul>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">私有化独立部署</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">可定制个性化功能</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">打通公司内部系统</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">网络隔离</p>
									</li>
									<li class="flex-center">
										<i class="tf">&#xe63f;</i>
										<p class="flex-grow">自主维护</p>
									</li>
								</ul>
							</dd>
						</dl>
					</div>
				</div>

				<div class="rights">
					<h1>详细权益对比</h1>
					
					<div class="list flex">
						<ul class="flex-grow">
							<div v-for="(group, i) in allRights">
								<li :key="`${i}`" class="group name"><b>{{group.name}}</b></li>
								<template v-for="(item, j) in group.list">
									<li :key="`${i}-${j}`" :class="{'z-active': activeRights == `${i}-${j}`}" v-on="rightsEvents(i, j)">{{item[0]}}</li>
								</template>
							</div>
						</ul>
						<ul class="flex-grow">
							<template v-for="(group, i) in allRights">
								<li :key="`${i}`" class="group" :class="{'name': i == 0}"><b>{{i == 0 ? '免费版' : ''}}</b></li>
								<template v-for="(item, j) in group.list">
									<li :key="`${i}-${j}`" :class="{'z-active': activeRights == `${i}-${j}`}" v-on="rightsEvents(i, j)">
										<i v-if="!item[1]" class="tf cross">&#xe60f;</i>
										<i v-else-if="item[1] === true" class="tf check">&#xe63f;</i>
										<span v-else>{{item[1]}}</span>
									</li>
								</template>
							</template>
						</ul>
						<ul class="flex-grow">
							<template v-for="(group, i) in allRights">
								<li :key="`${i}`" class="group" :class="{'name': i == 0}"><b>{{i == 0 ? '专业版' : ''}}</b></li>
								<template v-for="(item, j) in group.list">
									<li :key="`${i}-${j}`" :class="{'z-active': activeRights == `${i}-${j}`}" v-on="rightsEvents(i, j)">
										<i v-if="!item[2]" class="tf cross">&#xe60f;</i>
										<i v-else-if="item[2] === true" class="tf check">&#xe63f;</i>
										<span v-else>{{item[2]}}</span>
									</li>
								</template>
							</template>
						</ul>
					</div>
				</div>
			</div>
		</module>
	</page>
</template>

<script>
	import {mapGetters} from 'vuex'

	export default {
		data() {
			return {
				allRights: [{
					name: '基础服务',
					list: [
						['员工账号', 5, 60],
						['虚拟账号', false, 100],
						['产品数量', 60, '不限制'],
						['仓库数量', 1, '不限制'],
						['工序数量', 30, '不限制'],
						['绩效工资配置规则', 40, '不限制'],
						['报表类统计维度', '单维度', '不限制'],
						['报表类统计时间跨度', '30天', '不限制'],
						['业务日志', true, true],
						['系统实施', false, '1对1服务']
					]
				}, {
					name: '服务权益',
					list: [
						['系统培训', '远程协助', '1V1线上服务，保证教会'],
						['实施服务', false, '协助导入基础资料，配置流程'],
						['专属售后群', false, '专属实施人员、技术员，随时响应'],
						['使用过程合理优化需求响应', false, '通用性需求反馈给产品和技术，排期开发上线']
					]
				}, {
					name: '系统配置',
					list: [
						['自定义业务视图', 3, 20],
						['自定义业务字段', 3, 10],
						['自定义模板数据导出', false, true],
						['自定义数据看板', false, true],
						['自定义工厂LOGO', true, true],
						['自定义编号规则', false, true],
						['行业方案应用', true, true],
						['系统自动化配置', true, true],
						['系统通知', true, true]
					]
				}, {
					name: '销售管理',
					list: [
						['订单管理', true, true],
						['订单发货', true, true],
						['订单导出', false, true],
						['排产分析', true, true]
					]
				}, {
					name: '采购管理',
					list: [
						['采购管理', true, true],
						['采购收货', true, true],
						['采购发货', true, true]
					]
				}, {
					name: '生产管理',
					list: [
						['生产计划', true, true],
						['装配工单', false, true],
						['工单管理', true, true],
						['任务管理', true, true],
						['任务分配', true, true],
						['任务外发', false, true],
						['报工管理', true, true],
						['报工工作台', true, true],
						['排产日历', true, true]
					]
				}, {
					name: '质量管理',
					list: [
						['报工检验', false, true],
						['报工检验处理、返工', false, true],
						['生产入库检', false, true],
						['生产入库检处理、返工', false, true]
					]
				}, {
					name: '库存管理',
					list: [
						['入库单', true, true],
						['出库单', true, true],
						['盘点单', true, true],
						['库存收发明细', true, true],
						['库存余额', true, true],
						['库存余额明细', true, true],
						['进销存汇总', true, true],
						['库存变更记录', true, true]
					]
				}, {
					name: '委外管理',
					list: [
						['委外管理', false, true],
						['委外发货/动态', false, true],
						['委外收货/动态', false, true],
						['委外结算', false, true]
					]
				}, {
					name: '报表',
					list: [
						['质量统计', true, true],
						['员工绩效', true, true],
						['工资报表', true, true],
						['不良品项分布', true, true],
						['不良品项汇总', true, true],
						['不良品项明细', true, true],
						['生产报表', true, true],
						['在制品报表', true, true]
					]
				}, {
					name: '数据看板',
					list: [
						['车间看板', true, true],
						['自定义数据大屏', false, true]
					]
				}],
				activeRights: '2-2'
			}
		},

		computed: {
			...mapGetters(['freeEdition'])
		},
		
		created() {
			if (!this.freeEdition) {
				this.redirectTo('/');
			}
		},
		
		methods: {
			rightsEvents(i, j) {
				return {
					mouseenter: () => {
						this.activeRights = `${i}-${j}`;
					},

					mouseleave: () => {
						this.activeRights = '';
					}
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.bg {
		min-width: 1000px;
		height: 683px;
		margin-bottom: -683px;
		background-image: url('~@/assets/image/upgrade_bg.jpg');
		background-size: cover;
		background-position: center;
	}

	.main {
		width: 1000px;
		padding: 70px 0;
		margin: 0 auto;

		h1 {
			font-size: 50px;

			span {
				color: var(--color-main);
			}
		}

		h2 {
			margin: 20px 0 60px;
			font-size: 18px;
			font-weight: normal;
			color: #666;
		}

		.version {
			width: 100%;

			.item {
				box-sizing: border-box;
				width: 320px;
				border-top: 10px solid #fff;
				border-radius: 8px;
				padding: 38px 25px 60px;
				background: #fff;
				box-shadow: 0 3px 15px 0 rgba(172,172,172,.2);

				.title {
					font-size: 28px;
					font-weight: bold;
				}

				.explain {
					margin: 18px 0 30px;
					font-size: 14px;
					color: #999;
				}

				.sum {
					font-size: 24px;
					font-weight: bold;

					span {
						font-size: 15px;
						font-weight: normal;
					}
				}

				.button {
					position: relative;
					box-sizing: border-box;
					width: 100%;
					height: 44px;
					border-radius: 4px;
					margin-top: 20px;
					font-size: 18px;
					font-weight: bold;
					cursor: pointer;
					transition: all .15s ease;

					&:hover {
						box-shadow: 0 2px 3px 0 rgba(102,102,102,.15);
						transform: translate(0,-2px);
					}

					img {
						position: absolute;
						left: 50%;
						top: -22px;
						height: 32px;
						margin-left: 14px;
					}
				}

				dl {
					width: 100%;
					margin-top: 20px;

					dt {
						margin-bottom: 10px;

						p {
							line-height: 24px;
							font-size: 13px;
							color: #666;

							&:nth-child(n+2) {
								margin-top: 5px;
							}

							b {
								color: #000;
							}
						}
					}

					dd {
						li {
							gap: 10px;
							height: 32px;
							font-size: 13px;

							.tf {
								width: 18px;
								height: 18px;
								border-radius: 50%;
								line-height: 18px;
								font-size: 12px;
								text-align: center;
								color: #00B38A;
								background: #F1F6F5;
							}
						}
					}
				}
			}
		}
		
		.rights {
			width: 100%;

			h1 {
				padding: 70px 0 40px;
				font-size: 24px;
				text-align: center;
			}

			ul {
				&:nth-child(1) {
					flex-grow: 1.3;
				}

				&:nth-child(2),
				&:nth-child(2) li.name {
					background: #F5F8FC;
				}

				&:nth-child(3),
				&:nth-child(3) li.name {
					background: #FDF8F3;
				}

				> div {
					position: relative;
				}

				li {
					height: 50px;
					padding: 0 6px;
					line-height: 50px;
					transition: background .3s ease, box-shadow .3s ease;

					&.name {
						z-index: 1;
						position: sticky;
						top: 0px;
						background: #fff;
					}

					&.group {
						border-bottom: 1px solid #eee;
					}

					&.z-active {
						box-shadow: 0 0 10px 0 #eee;
						background: #fff;
					
						^[-2]:nth-child(2) ^[-1..-1] {
							position: relative;
							box-shadow: -10px 0px 0px 0px #fff, 10px 0px 0px 0px #fff, 0 0 10px 0 #eee;
						}
					}
					
					^[-1]:nth-child(n+2) ^[-1..-1] {
						text-align: center;
					}

					b {
						font-size: 20px;
					}

					.tf {
						width: 20px;
						height: 20px;
						border-radius: 50%;
						line-height: 20px;
						font-size: 12px;
						text-align: center;
						color: #fff;

						&.cross {
							background: #f00;
						}

						&.check {
							background: #00B38A;
						}
					}
				}
			}
		}
	}
</style>
